import React from 'react';
import { Search, BarChart2, Sparkles } from 'lucide-react';
export function FeatureCards() {
  return <div className="w-full max-w-5xl mx-auto px-6 pb-20" data-id="element-305">
      <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-306">Features</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-307">
        <div className="bg-[#F0F9F9] rounded-2xl p-6 border border-teal-50/50" data-id="element-308">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm border border-gray-100" data-id="element-309">
            <Search size={18} className="text-teal-600" data-id="element-310" />
          </div>
          <h4 className="text-lg font-bold text-gray-900 mb-3" data-id="element-311">
            Identify High-Value Segments
          </h4>
          <p className="text-gray-600 text-sm leading-relaxed" data-id="element-312">
            Pinpoint the exact customer profiles that drive the most revenue for
            your business.
          </p>
        </div>

        <div className="bg-[#F0F9F9] rounded-2xl p-6 border border-teal-50/50" data-id="element-313">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm border border-gray-100" data-id="element-314">
            <BarChart2 size={18} className="text-teal-600" data-id="element-315" />
          </div>
          <h4 className="text-lg font-bold text-gray-900 mb-3" data-id="element-316">
            Map Market Penetration
          </h4>
          <p className="text-gray-600 text-sm leading-relaxed" data-id="element-317">
            Visualize your current market share and discover untapped whitespace
            opportunities.
          </p>
        </div>

        <div className="bg-[#F0F9F9] rounded-2xl p-6 border border-teal-50/50" data-id="element-318">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm border border-gray-100" data-id="element-319">
            <Sparkles size={18} className="text-teal-600" data-id="element-320" />
          </div>
          <h4 className="text-lg font-bold text-gray-900 mb-3" data-id="element-321">
            AI-Powered Recommendations
          </h4>
          <p className="text-gray-600 text-sm leading-relaxed" data-id="element-322">
            Get actionable, data-driven insights on where to focus your
            expansion efforts next.
          </p>
        </div>
      </div>
    </div>;
}